import { Box, TextField, Typography } from "@mui/material";
import { StyledArtTable } from "./ArtTable.styled";
import { useArt } from "../../stores/useArt";
import { useProfile } from "../../stores/useProfile";
import { useEffect, useState } from "react";
import { ArtTableRow } from "./ArtTableRow";
import { Art } from "../../Models/Art";

type ArtTableProps = {
  onImageClick: (artItemId: number) => void;
};

export const ArtTable = ({ onImageClick }: ArtTableProps) => {
  const [artList, setArtList] = useState<Art[]>([]);
  const [filteredArtList, setFilteredArtList] = useState<Art[]>([]);
  const [filtertext, setFilterText] = useState<string>("");

  const { fetchAllArt } = useArt();
  const { user } = useProfile();

  const updateItems = async () => {
    if (!user) return;
    const res = await fetchAllArt();
    if (res) setArtList(res);
  };

  useEffect(() => {
    updateItems();
  }, [user]);

  useEffect(() => {
    const lower = filtertext.toLowerCase();

    const result = artList.filter((art) => {
      return (
        art.id?.toString().includes(lower) ||
        art.title.toLowerCase().includes(lower) ||
        art.description.toLowerCase().includes(lower) ||
        art.sellState.toLowerCase().includes(lower) ||
        art.type.toLowerCase().includes(lower)
      );
    }).reverse();

    

    setFilteredArtList(result);
  }, [filtertext, artList]);

  return (
    <StyledArtTable>
      <Box className="filterBar">
        <TextField
          fullWidth
          placeholder="Zoeken..."
          onChange={(e) => setFilterText(e.target.value)}
        />
      </Box>
      <Box className="table">
        <Box className="header">
          <Typography variant="h4" className="id">
            ID
          </Typography>
          <Typography variant="h4" className="title">
            Titel
          </Typography>
          <Typography variant="h4" className="description">
            Beschrijving
          </Typography>
          <Typography variant="h4" className="type">
            Type
          </Typography>
          <Typography variant="h4" className="sellstate">
            Verkoopstatus
          </Typography>
          <Typography variant="h4" className="vieuws">
            Views
          </Typography>
          <Typography variant="h4" className="date">
            Datum
          </Typography>
          <Typography variant="h4" className="actions">
            Acties
          </Typography>
        </Box>
        <Box className="content">
          {filteredArtList.map((artItem) => (
            <ArtTableRow
              artItem={artItem}
              onSave={updateItems}
              onImageClick={(artItemId) => onImageClick(artItemId)}
            />
          ))}
        </Box>
      </Box>
    </StyledArtTable>
  );
};
